// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/custom_event_names" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsCustomEventNames } from "./constants";
import type { CustomEventNamesResult } from "./types";

const DEFAULT_ITEM_LIMIT = 250;

export const getCustomEventNames = reactQueryFetcherAdapter(
  appsAppGroupIdChartsCustomEventNames,
  (
    signal: AbortSignal,
    appGroupId: string,
    query: string,
    limit = DEFAULT_ITEM_LIMIT
  ): Promise<CustomEventNamesResult> => {
    return fetch(`/apps/${appGroupId}/charts/custom_event_names`, "GET", { query: query || "", limit }, { signal });
  }
);
